import React, { Component } from 'react'

class SvgComponent extends Component {
  render() {
    const { renderComponent: RenderComponent, ...other } = this.props
    return <RenderComponent {...other} />
  }
}

export default SvgComponent
